var __WEBPACK_NAMESPACE_OBJECT__ = devowlWp_realUtils;